import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  GetTestCaseResponse,
  ModelTestCase
} from '@eggplant/types'

export interface Props {
  id: string
  spinSize?: number
  children?: (testCase: GetTestCaseResponse) => React.ReactNode
  onSuccess?: (testCase: ModelTestCase) => void
  onError?: (error: Error) => void
}

const GetTestCaseRequest = ({
  id,
  spinSize,
  children,
  onSuccess,
  onError
}: Props) => {
  const url = `${MODELER_SERVICE}/test_cases/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      spinnerSize={spinSize}
      url={url}
    />
  )
}

export default GetTestCaseRequest
